const BOT_SESSION_PREFIX = 'va-bot.';
const LOGGED_IN_FLOW = `${BOT_SESSION_PREFIX}loggedInFlow`;
const IN_AUTH_EXP = `${BOT_SESSION_PREFIX}inAuthExperience`;
const RECENT_UTTERANCES = `${BOT_SESSION_PREFIX}recentUtterances`;
const CONVERSATION_ID_KEY = `${BOT_SESSION_PREFIX}conversationId`;
const IS_TRACKING_UTTERANCES = `${BOT_SESSION_PREFIX}isTrackingUtterances`;
const TOKEN_KEY = `${BOT_SESSION_PREFIX}token`;
const TOKEN_EXPIRES_AT = `${BOT_SESSION_PREFIX}tokenExpiresAt`;
const CONVERSATION_TOKEN_KEY = `${BOT_SESSION_PREFIX}conversationToken`;
const FIRST_CONNECTION = `${BOT_SESSION_PREFIX}firstConnection`;
const SKILL_EVENT_VALUE = `${BOT_SESSION_PREFIX}skillEventValue`;
const DISCLAIMER_ACCEPTED_KEY = `${BOT_SESSION_PREFIX}disclaimerAccepted`;
const AUTHENTICATED_CONVERSATION_ID = `${BOT_SESSION_PREFIX}authenticatedConversationId`;

function setStorageItem(key, value, json = false) {
  if (json) {
    sessionStorage.setItem(key, JSON.stringify(value));
  } else {
    sessionStorage.setItem(key, value);
  }
}

function getStorageItem(key, json = false) {
  const raw = sessionStorage.getItem(key);
  if (raw === null) return null;
  if (json) {
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }
  return raw;
}

export function getEventSkillValue() {
  return getStorageItem(SKILL_EVENT_VALUE);
}

export function setEventSkillValue(value) {
  setStorageItem(SKILL_EVENT_VALUE, value);
}

export function getLoggedInFlow() {
  return getStorageItem(LOGGED_IN_FLOW);
}

export function setLoggedInFlow(value) {
  setStorageItem(LOGGED_IN_FLOW, value);
}

export function getInAuthExp() {
  return getStorageItem(IN_AUTH_EXP);
}

export function setInAuthExp(value) {
  setStorageItem(IN_AUTH_EXP, value);
}

export function getRecentUtterances() {
  return getStorageItem(RECENT_UTTERANCES, true);
}

export function setRecentUtterances(value) {
  setStorageItem(RECENT_UTTERANCES, value, true);
}

export function getConversationIdKey() {
  return getStorageItem(CONVERSATION_ID_KEY);
}

export function setConversationIdKey(value) {
  setStorageItem(CONVERSATION_ID_KEY, value);
}

export function getIsTrackingUtterances() {
  return getStorageItem(IS_TRACKING_UTTERANCES);
}

export function setIsTrackingUtterances(value) {
  setStorageItem(IS_TRACKING_UTTERANCES, value, true);
}

export function getTokenKey() {
  return getStorageItem(TOKEN_KEY);
}

export function setTokenKey(value) {
  setStorageItem(TOKEN_KEY, value);
}

export function getTokenExpiresAt() {
  const val = getStorageItem(TOKEN_EXPIRES_AT);
  return val ? Number(val) : null;
}

export function setTokenExpiresAt(value) {
  setStorageItem(TOKEN_EXPIRES_AT, String(value));
}

export function getConversationTokenKey() {
  return getStorageItem(CONVERSATION_TOKEN_KEY);
}

export function setConversationTokenKey(value) {
  setStorageItem(CONVERSATION_TOKEN_KEY, value);
}

export function getDisclaimerAccepted() {
  return getStorageItem(DISCLAIMER_ACCEPTED_KEY) === 'true';
}

export function setDisclaimerAccepted(value) {
  setStorageItem(DISCLAIMER_ACCEPTED_KEY, String(value));
}

/**
 * The conversation Direct Line accepted a sign-in code for. A resumed
 * conversation that isn't this one never got a code to the bot.
 */
export function getAuthenticatedConversationIdKey() {
  return getStorageItem(AUTHENTICATED_CONVERSATION_ID);
}

export function setAuthenticatedConversationIdKey(value) {
  setStorageItem(AUTHENTICATED_CONVERSATION_ID, value);
}

export function clearBotSessionStorage(forceClear) {
  const botSessionKeys = Object.keys(sessionStorage);
  const loggedInFlow = getLoggedInFlow();
  const inAuthExp = getInAuthExp();
  const expectToClear = loggedInFlow !== 'true' && inAuthExp !== 'true';

  if (!forceClear && inAuthExp === 'true' && loggedInFlow !== 'true') {
    return;
  }

  const excludeClear = [
    FIRST_CONNECTION,
    CONVERSATION_ID_KEY,
    TOKEN_KEY,
    TOKEN_EXPIRES_AT,
    CONVERSATION_TOKEN_KEY,
    DISCLAIMER_ACCEPTED_KEY,
    AUTHENTICATED_CONVERSATION_ID,
  ];

  if (!forceClear && loggedInFlow === 'true' && inAuthExp !== 'true') {
    excludeClear.push(LOGGED_IN_FLOW);
    excludeClear.push(RECENT_UTTERANCES);
    excludeClear.push(CONVERSATION_ID_KEY);
    excludeClear.push(TOKEN_KEY);
  }

  if (forceClear || expectToClear || excludeClear.length > 3) {
    botSessionKeys.forEach(sessionKey => {
      if (
        sessionKey.includes(BOT_SESSION_PREFIX) &&
        !excludeClear.includes(sessionKey)
      ) {
        sessionStorage.removeItem(sessionKey);
      }
    });
  }
}

export function storeUtterances(event) {
  const { data } = event;
  if (
    data.type === 'message' &&
    data.text &&
    data.text.length > 0 &&
    data.from.role === 'user'
  ) {
    let utterances;
    const recentUtterances = getRecentUtterances();
    if (recentUtterances === null) {
      utterances = ['', ''];
    } else {
      utterances = recentUtterances;
    }

    utterances.push(data.text);
    utterances.shift();
    setRecentUtterances(utterances);
  }
}
